/**
 * Cart Trialpack Subscription Info Modal
 * Converts .selling-plan-name elements to modal triggers when text matches
 */
class CartTrialpackSubscriptionInfoModal extends HTMLElement {
  constructor() {
    super();
    this.modalId = 'cart-trialpack-subscription-info';
    this.triggerClass = 'cart-trialpack-subscription-info-trigger';
  }

  connectedCallback() {
    this.modalTriggerText = this.dataset.modalTriggerText || '';
    if (!this.modalTriggerText) return;

    this.processSellingPlanNames();
    this.subscribeToCartUpdates();
  }

  subscribeToCartUpdates() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        requestAnimationFrame(() => this.processSellingPlanNames());
      });
    }
  }

  processSellingPlanNames() {
    const el = document.querySelector('.selling-plan-name');
    if (!el || el.querySelector('.' + this.triggerClass)) return;

    el.innerHTML = el.innerHTML.replace(
      this.modalTriggerText,
      `<lab-modal-trigger data-target="${this.modalId}" class="${this.triggerClass}">${this.modalTriggerText}</lab-modal-trigger>`
    );
  }
}

customElements.define('cart-trialpack-subscription-info-modal', CartTrialpackSubscriptionInfoModal);

